/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

const PaginationWrapper = styled.div`
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 12px;
`;

function CustomPagination({ onChangeHandle, currentPageNumber, nextCursor, prevCursor }) {
  return (
    <PaginationWrapper>
      <Button
        onClick={() => onChangeHandle('back')}
        disabled={currentPageNumber === 1 || prevCursor === null}
      >
        <LeftOutlined />
      </Button>
      <span>{currentPageNumber}</span>
      <Button onClick={() => onChangeHandle('next')} disabled={nextCursor === null}>
        <RightOutlined />
      </Button>
    </PaginationWrapper>
  );
}

CustomPagination.defaultProps = {
  prevCursor: null,
  nextCursor: null
};

CustomPagination.propTypes = {
  onChangeHandle: PropTypes.func.isRequired,
  nextCursor: PropTypes.string,
  prevCursor: PropTypes.string,
  currentPageNumber: PropTypes.number.isRequired
};

export default CustomPagination;
